import * as React from 'react';
import classNames from 'classnames';
import { observer } from 'mobx-react';
import { useCallback, useState } from 'react';
import { IStepControl } from '../../../domains/wizard';
import { useStore } from '../../../store';

export interface Props {
  index: number;
  title: string;
  completed?: boolean;
  isAllCompleted?: boolean;
  stepControl: IStepControl;
}

export const StepNav = observer(({ completed, index, title, stepControl }: Props) => {
  const { activeStepIndex, setActiveStep, lastStepIndex, isAllCompleted } = stepControl;
  const { signUpStore } = useStore();
  const [isClicked, setIsClicked] = useState(false);
  const stepClasses = classNames('step-label', index === activeStepIndex ? 'active' : 'inactive', completed && 'completed');
  const isClickable = useCallback(() => completed || (isAllCompleted() && index === lastStepIndex), [completed, isAllCompleted]);

  const handleClick = () => {
    setIsClicked(true);
    setActiveStep(index).finally(() => setIsClicked(false));
  };

  return (
    <button className={stepClasses} onClick={() => isClickable() && handleClick()}>
      <span className={isClicked && signUpStore.isLoading ? 'loading-primary' : ''}>{index + 1}</span>
      {title}
    </button>
  );
});
